function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.126 3.108H1.51a.653.653 0 00-.653.653v12.405c0 .361.293.653.653.653h1.35v-4.135c0-.36.292-.653.653-.653h2.611c.36 0 .653.293.653.653v4.135H8.78V3.761a.653.653 0 00-.653-.653zm-3.96 6.965a.653.653 0 01-1.306 0v-.87a.653.653 0 011.305 0v.87zm0-3.482a.653.653 0 01-1.306 0V5.72a.653.653 0 011.305 0v.87zm2.611 3.482a.653.653 0 11-1.306 0v-.87a.653.653 0 011.306 0v.87zm0-3.482a.653.653 0 01-1.306 0V5.72a.653.653 0 011.306 0v.87z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.166 13.337H5.47v3.482H4.166v-3.482zM14.33.714h-1.524a.653.653 0 00-.648.572l-.718 5.74h4.255l-.718-5.74a.653.653 0 00-.648-.572zM18.252 1.286l-.718 5.74h4.254l-.717-5.74a.653.653 0 00-.648-.572H18.9a.653.653 0 00-.648.572zM22.49 8.332H10.085v8.487h2.83v-3.264c0-.36.292-.653.652-.653h6.094c.36 0 .653.292.653.653v3.264h2.176c.36 0 .653-.292.653-.653V8.984a.653.653 0 00-.653-.652zm-8.923 3.264h-.87a.653.653 0 010-1.306h.87a.653.653 0 010 1.306zm3.482 0h-.87a.653.653 0 010-1.306h.87a.653.653 0 010 1.306zm3.482 0h-.87a.653.653 0 010-1.306h.87a.653.653 0 010 1.306z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.22 14.208h4.788v2.611H14.22v-2.611z",
  fill: "#fff"
});

function SvgIconSiteSelection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgIconSiteSelection;